import { requestJson } from './requestJson';

// Always resolves — signed out is a normal answer, not an error.
export async function getSessionCreator(): Promise<{
  signed_in: boolean;
  email?: string;
  display_name?: string | null;
  avatar_url?: string | null;
}> {
  return await requestJson('/api/session');
}
